import "./App.css";
import React from "react";
import { LivePriceProvider } from "./hooks/useLivePrice";
import TopStrip from "./components/TopStrip";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import AtAGlance from "./components/AtAGlance";
import PhysicalPlatinum from "./components/PhysicalPlatinum";
import AboutXPTY from "./components/AboutXPTY";
import WhyPlatinum from "./components/WhyPlatinum";
import HowItWorks from "./components/HowItWorks";
import Transparency from "./components/Transparency";
import Market from "./components/Market";
import Xylapay from "./components/Xylapay";
import FAQ from "./components/FAQ";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";

function App() {
  return (
    <LivePriceProvider>
      <div className="App" id="top">
        <TopStrip />
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <AtAGlance />
          <PhysicalPlatinum />
          <AboutXPTY />
          <WhyPlatinum />
          <HowItWorks />
          <Transparency />
          <Market />
          <Xylapay />
          <FAQ />
          <FinalCTA />
        </main>
        <Footer />
      </div>
    </LivePriceProvider>
  );
}

export default App;
